import { v4 as uuidv4 } from 'uuid';

export function FormInputRadiogroup(props = {}, childrenComponents = []) {
	return {
		componentName: 'FormInputRadiogroup',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pointer: '',
				label: '',
			},
			props,
		),
		childrenComponents,
	};
}
